<!-- Modernized layout -->
<app-header></app-header>
<div id="print-section" class="page-wrapper">
  <div class="status-card" [ngClass]="{'success': status === 'Success', 'failure': status === 'Failure'}">
    
    <div class="card-header">
      <div class="status-icon" *ngIf="status === 'Success'">
        <i class="fa fa-check"></i>
      </div>
      <div class="status-icon failure-icon" *ngIf="status === 'Failure'">
        <i class="fa fa-exclamation"></i>
      </div>
      <div class="status-text">
        <h1 class="title">Invoice Payment</h1>
        <p class="subtitle" *ngIf="status === 'Success'">
          Your invoice payment has been processed successfully.
        </p>
        <p class="subtitle" *ngIf="status === 'Failure'">
          Sorry, there was an issue processing your invoice payment.
        </p>
      </div>
      <button type="button" class="icon-btn print-btn" (click)="print()" aria-label="Print receipt">
        <i class="fa fa-print"></i>
      </button>
    </div>

    <div class="divider"></div>

    <div class="section" *ngIf="transactionStatus.transId">
      <label class="section-label">Transaction ID</label>
      <div class="section-value transIDWordBreak">{{ transactionStatus.transId }}</div>
    </div>

    <div class="section" *ngIf="transactionStatus.orderIds">
      <label class="section-label">Order ID(s)</label>
      <div class="section-value">{{ transactionStatus.orderIds }}</div>
    </div>

    <div class="section" *ngIf="transactionStatus.invoiceIds">
      <label class="section-label">Invoice ID(s)</label>
      <div class="section-value">{{ transactionStatus.invoiceIds }}</div>
    </div>

    <div class="payment-block">
      <div class="payment-icon">
        <i class="fa fa-credit-card"></i>
      </div>
      <div class="payment-info">
        <h2 class="payment-heading">Payment Details</h2>
        <div class="amount-row">
          <div class="amount-label" *ngIf="transactionStatus.paymentMode === 'ACH'">
            Total Net Discount Price
          </div>
          <div class="amount-label" *ngIf="transactionStatus.paymentMode === 'CC'">
            Total Net Regular Price
          </div>
          <div class="amount-value">
            {{ transactionStatus.transAmount | currency:'USD' }}
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <button
        type="button"
        (click)="home($event)"
        class="action-btn"
        [ngClass]="{'success-btn': status === 'Success', 'failure-btn': status === 'Failure'}">
        <i class="fa fa-home home_icon"></i>
        <span>Go Home</span>
      </button>
    </div>

  </div>
</div>